import { IconName } from 'ui/components'

import * as SC from './styles'

type Props = {
  url?: string
  onClick?: () => void
}

export const EditItem = (props: Props) => {
  const { url, onClick } = props

  return (
    <SC.EditItem
      to={url}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
      data-qa={`table-action-EDIT`}
    >
      <SC.WrappedIcon name={IconName.EDIT_OUTLINE} />
      <span>Edit</span>
    </SC.EditItem>
  )
}
